import React from 'react';
import {
  Draggable,
} from 'react-beautiful-dnd';

import {
  Flex,
} from 'web-styled';

import WeekWorkout from './WeekWorkout';
import * as S from './styled';

type Props = {
  workouts: any[],
  readOnly: boolean,
  selectedId: number,
  resourceType: string,
  droppableProvided: any,
  onSelectWorkout: { (workout: any): void },
};

const WeekWorkouts = ({
  workouts,
  readOnly,
  selectedId,
  resourceType,
  droppableProvided,
  onSelectWorkout,
}: Props) => {
  if (!workouts.length) {
    const props = readOnly
      ? {}
      : {
        ref: droppableProvided.innerRef,
      };

    return (
      <Flex
        {...props}
        width="100%"
        style={{ minHeight: '42px' }}
      >
        <S.Empty>
          Empty
        </S.Empty>
      </Flex>
    );
  }

  return readOnly ? (
    <Flex
      column
      shrink="0"
      width="100%"
    >
      {workouts.map(workout => (
        <S.Workout
          key={workout.id}
          active={workout.id === selectedId}
          onClick={() => {
            onSelectWorkout(workout);
          }}
        >
          <S.WorkoutName>
            {workout.name}
          </S.WorkoutName>
        </S.Workout>
      ))}
    </Flex>
  ) : (
    <Flex
      column
      shrink="0"
      width="100%"
      ref={droppableProvided.innerRef}
    >
      {workouts.map((workout, index) => (
        <Draggable
          key={workout.id}
          index={index}
          draggableId={String(workout.id)}
        >
          {provided => (
            <WeekWorkout
              active={workout.id === selectedId}
              workout={workout}
              resourceType={resourceType}
              draggableProvided={provided}
              onClick={() => {
                onSelectWorkout(workout);
              }}
            />
          )}
        </Draggable>
      ))}
      {droppableProvided.placeholder}
    </Flex>
  );
};

export default WeekWorkouts;
